<template>
    <div class="waypoint">

        <UploadedImage :image-path="BPPoint.MainPic"/>

        <div class="infos">

            <template v-if="language=='de'">
                <h1>{{ BPPoint.de.Titel }}</h1>
                <p>{{ BPPoint.de.Kurzbeschreibung }}</p>
            </template>
            <template v-if="language=='pl'">
                <h1>{{ BPPoint.pl.Titel }}</h1>
                <p>{{ BPPoint.pl.Kurzbeschreibung }}</p>
            </template>
        </div>

        <Quiz :questions="BPPoint.Fragen" :waypointid="BPPoint.id"></Quiz>

        <Karte :Lat="BPPoint.latitude" :Lon="BPPoint.longitude"></Karte>

        <Slider :pics="BPPoint.Bilder"></Slider>
    </div>
</template>

<script type="text/babel">

    import UploadedImage from "../components/UploadedImage";
    import Karte from "../components/Karte";
    import Slider from "../components/Slider";
    import Quiz from "../components/Quiz";

    export default {
        name: 'waypointView',
        props: ['waypointId'],
        components: {Quiz, Slider, UploadedImage, Karte},
        computed: {
            language: function () {
                return this.$root.$i18n.locale;
            },
            BPPoint: function () {
                let self = this;
                return this.$root.BPPoints.find((item) => item.id === self.waypointId)
            }
        }
    }
</script>
